module.exports = __webpack_public_path__ + "media/images/transfer-switch-43fb26d0ace7236244c0cea22b3b86bd.svg";